import React from "react";
import ProductConfirmationSvg from "../../../assets/product-confirmation-svg.svg";

function ProductConfirmationModal({ isOpen, onClose, onConfirm, orderItem }) {
  if (!isOpen) return null;

  const handleCancel = () => {
    if (onConfirm && orderItem) {
      onConfirm(orderItem);
    }
    onClose();
  };

  return (
    <div
      className="orders-cancel-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="orders-cancel-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancelOrderTitle"
      >
        <div className="orders-cancel-modal-icon">
          <img src={ProductConfirmationSvg} alt="Cancel" />
        </div>
        <h3 className="orders-cancel-modal-title" id="cancelOrderTitle">
        Product Confirmation
        </h3>
        <p className="orders-cancel-modal-message">
        Are you sure you want to confirm this products as an order?
        </p>
        <div className="orders-cancel-modal-actions">
          <button
            type="button"
            className="orders-cancel-modal-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="orders-product-confirmation-modal-delete-btn"
            onClick={handleCancel}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductConfirmationModal;
